var screenSaver = {};

function startScreenSaver(options) {
  //* attach event listeners to exit screensaver
  attachScreenSaverEventListeners();
  if(!screenSaver.initiated) {
    //* set screensaver options
    screenSaver.options = {
       timeout: options.timeout || 60000, //* default timer to start screensaver is 10 minutes
        width: options.width || 25,   //* default width is 25rem
        height: options.height || 25, //* default height is 25rem
        exitTimeout: options.exitTimeout || null, //* default timer to exit screensaver is disabled
    }
    //* create elements
    var overlay = document.createElement("div");
    overlay.setAttribute('class', 'screensaver-overlay');
    document.body.appendChild(overlay);
    var createBadge = document.createElement("div");
    createBadge.setAttribute('id', 'saver-badge');
    document.body.appendChild(createBadge);
    createBadge.style.width = screenSaver.options.width + 'rem';
     createBadge.style.height = screenSaver.options.height + 'rem';
  }

  document.getElementsByTagName("body")[0].classList.remove('screensaver');
  screenSaver.initiated = true;
  screenSaver.setTimeoutValue = screenSaver.options.timeout;
  screenSaver.setTimeoutExit = screenSaver.options.timeoutExit;
  screenSaver.setTimeout = null; //* clear timeout
  screenSaver.inProgress = false;
  screenSaver.timerStarted = false;

  clearTimeout(screenSaver.setTimeout);

  screenSaver.setTimeout = setTimeout(function() {
    document.getElementsByTagName("body")[0].classList.add('screensaver');
      screenSaver.inProgress = true;
      var saverBadge = document.getElementById("saver-badge");
      clearInterval(screenSaver.setInterval); //* clear badge display interval
      screenSaver.setInterval = null;
      //* get dimensions in em
      var windowHeight = window.innerHeight / parseFloat(window.getComputedStyle(document.getElementsByTagName("body")[0], null).getPropertyValue('font-size'));
      var windowWidth = window.innerWidth / parseFloat(window.getComputedStyle(document.getElementsByTagName("body")[0], null).getPropertyValue('font-size'));
      var saverTopValue = windowWidth / 2;
      var saverLeftValue = windowHeight - 2;
      var dx = 1;
      var dy = -1;

      screenSaver.setInterval = setInterval(function() {
        if (screenSaver.inProgress === true) {
          saverBadge.classList.remove('visible');
          setTimeout(function() {
            saverBadge.offsetWidth = saverBadge.offsetWidth;
            saverBadge.classList.add('visible');
          }, 1);
          if(saverTopValue + dx > windowHeight-2 || saverTopValue + dx < 2) {
              dx = -dx;
          }
          if(saverLeftValue + dy > windowWidth-2 || saverLeftValue + dy < 2) {
              dy = -dy;
          }
          saverTopValue += dx;
          saverLeftValue += dy;
          if (saverTopValue <= 0) { //* make sure the badge doesn't go off the screen
            saverTopValue = saverTopValue + 2;
          }
          if (saverLeftValue <= 0) {
            saverLeftValue = saverLeftValue + 2;
          }
          saverBadge.style.top = saverTopValue + 'rem';
          saverBadge.style.left = saverLeftValue + 'rem';
          if(screenSaver.timerStarted === false && screenSaver.options.exitTimeout != null) {
            startScreenSaverTimer();
          }
        }
      }, 60);
    }, screenSaver.setTimeoutValue);
}

function startScreenSaverTimer() {
  screenSaver.timerStarted = true;
  setTimeout(function() {
    stopScreenSaver();
  }, screenSaver.setTimeoutExit);
}

function stopScreenSaver() {
  startScreenSaver();
  clearInterval(screenSaver.setInterval);
  document.getElementsByTagName("body")[0].classList.remove('screensaver');
  screenSaver.timerStarted = false;
}

function attachScreenSaverEventListeners() {
  var events = ['touchstart', 'mousedown', 'mousemove', 'touchmove', 'keypress', 'scroll'];
  var resetScreenSaver = function(e) {
    if (screenSaver.inProgress) {
      e.stopPropagation();
      e.preventDefault();
    }
    clearTimeout(screenSaver.setTimeout);
    clearInterval(screenSaver.setInterval);
    document.getElementsByTagName("body")[0].classList.remove('screensaver');
    startScreenSaver();
  }
  var checkClick = function(e) {
    if (screenSaver.inProgress) {
      startScreenSaver();
    }
  }
  var bindEvents = function(eventName) {
    document.addEventListener(eventName, screenSaver.initialize);
    //* bind click as fallback for touchstart and mousedown
    document.addEventListener('click', checkClick);
    document.addEventListener('touchstart', checkClick);
    document.addEventListener('mousedown', checkClick);
    document.addEventListener('mousemove', checkClick);
    document.addEventListener('touchmove', checkClick);
    document.addEventListener('keypress', checkClick);
    document.addEventListener('scroll', checkClick);
  }

  var unbindEvents = function(eventName) {
    document.removeEventListener(eventName, screenSaver.initialize);
  }

  bindEvents();
}
